export default "__VITE_ASSET__27859c21__"